import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    key: "4dddd59bdab77bace6189d001f96487e",
    user: { client_code: "57129776", id: "Hek68PU5r76", password: "D86utK8Mn7" },
    papi_token: "aW5kaWFpbmZvbGluZVw1cGFuZHJvaWQ6MnhxUzV2L1g5Og==",
};
export const counterSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
    },
});
export const { setUser } = counterSlice.actions;
export default counterSlice.reducer;
